<script lang="ts">
  import { onDestroy } from "svelte";
  import { destroySvelteComponentInstance, mountFederatedSvelteComponent } from "../../../lib/mountFederatedSvelteComponent";
  import RemoteLoading from "./RemoteLoading.svelte";

  export let opportunities: any[] = [];
  export let filterStatus: string = "all";

  export let onSelectOpportunity: (detail: any) => void = () => {};
  export let onFilterStatusChange: (detail: string) => void = () => {};

  let container: HTMLDivElement | null = null;
  let instance: any = null;
  let RemoteComponent: any = null;
  let loadError = false;

  let columns: Array<{
    key: string;
    label: string;
    type?: "text" | "status" | "boolean" | "time";
    align?: "left" | "center" | "right";
  }> = [
    { key: "awsOppId",       label: "AWS ID",        type: "text" },
    { key: "dealName",       label: "Deal Name",      type: "text" },
    { key: "projectTitle",   label: "Project Title",  type: "text" },
    { key:"origination", label:"Origination", type:"text"},
    { key: "acelinkSynced",  label: "Acelink",        type: "boolean", align: "center" },
    { key: "awsSynced",      label: "AWS",            type: "boolean", align: "center" },
    { key: "hubspotSynced",  label: "HubSpot",        type: "boolean", align: "center" },
    { key: "status",         label: "Status",         type: "status" },
    { key: "lastUpdate",     label: "Last Update",    type: "time" },
  ];
  
  function mount() {
    if (!container) return;
    const doMount = (Component: any) => {
      instance = mountFederatedSvelteComponent(instance, Component, {
        target: container!,
        props: {
          opportunities,
          filterStatus,
          columns,
          onSelectOpportunity: (item: any) => onSelectOpportunity(item),
          onFilterStatusChange: (status: string) => {            
            filterStatus = status; // ✅ update local state first
            onFilterStatusChange(status);
          },
        },
      });
    };
    if (RemoteComponent) doMount(RemoteComponent);
    else {
      // @ts-ignore - App2 remote
      import("App2/opportunitiesTable")
        .then((m) => {
          RemoteComponent = m.default;
          doMount(RemoteComponent);
        })
        .catch((err) => {
          loadError = true;
          console.warn("App2/opportunitiesTable not available:", err);
        });
    }
  }

  $: if (container && !instance) mount();
  $: if (instance) instance.$set({ opportunities, filterStatus, columns }); // ✅ added columns

  onDestroy(() => {
    instance = destroySvelteComponentInstance(instance);
  });
</script>

<div class="relative w-full min-h-[12rem]">
  {#if !instance && !loadError}
    <RemoteLoading minHeight="12rem" />
  {/if}
  <div bind:this={container} data-opportunities-table-host class="w-full"></div>
</div>